import { render } from "./ProjectTypeForm.vue?vue&type=template&id=5727a4c3"
import script from "./ProjectTypeForm.vue?vue&type=script&lang=js"
export * from "./ProjectTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__